import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PopupContext = createContext();

export const usePopup = () => useContext(PopupContext);

export const PopupProvider = ({ children }) => {
  const [popups, setPopups] = useState([]);
  const location = useLocation();

  useEffect(() => {
    clearAllPopups();
  }, [location.pathname]);

  const showPopup = (popupElement, key = Date.now()) => {
    setPopups((prev) => [...prev, { key, element: popupElement }]);
    console.log(popups);
  };

  const removePopup = (key) => {
    setPopups((prev) => prev.filter((p) => p.key !== key));
  };

  const clearAllPopups = () => {
    setPopups([]);
  };

  return (
    <PopupContext.Provider value={{ showPopup, removePopup, clearAllPopups }}>
      {children}
      <div className="popup-wrappers-container">
        {popups.map(({ key, element }) => (
          <div key={key} className="popup-wrapper">
            {element}
          </div>
        ))}
      </div>
    </PopupContext.Provider>
  );
};
